import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';
import '@fontsource-variable/inter';
import './global.css';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { HttpError } from './api';
import { ErrorBoundary } from './components/ErrorBoundary';
import { refreshCounters } from './liveCounters';
import { cssResolver, theme } from './theme';


const queryClient: QueryClient = new QueryClient({
  // po każdej udanej zmianie (wykonanie, przejęcie, zaplanowanie…) — liczniki do zrobienia od razu aktualne
  mutationCache: new MutationCache({ onSuccess: () => refreshCounters(queryClient) }),
  defaultOptions: {
    queries: {
      retry: (count, err) => !(err instanceof HttpError && err.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={theme} cssVariablesResolver={cssResolver} defaultColorScheme="light">
      <Notifications position="bottom-right" />
      <ModalsProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </BrowserRouter>
        </QueryClientProvider>
      </ModalsProvider>
    </MantineProvider>
  </StrictMode>,
);
